const data = {
  usd: {
    greetingCard: 13.99,
    "faceMounting-a1": 375,
    "faceMounting-a2": 250,
    "canvasPrint-noFrame": 89.99,
    "canvasPrint-woodenFrame": 139.99,
    "postcards-set12": 29.99,
    "postcards-set20": 42.99,
    "timeCapsule-empty": 48.99,
    "timeCapsule-2018": 48.99,
    printItYourself: 8.95,
    "au-std": w => ((55.75 * w + 170.25) * 1.034) / 7.6,
    "be-std": w => ((60 * w + 170) * 1.034) / 7.6,
    "br-std": w => ((120 * w + 220) * 1.034) / 7.6,
    "kh-std": w => ((80 * w + 77) * 1.034) / 7.6,
    "ca-std": w => ((70.5 * w + 200.5) * 1.034) / 7.6,
    "dk-std": w => ((120 * w + 220) * 1.034) / 7.6,
    "fi-std": w => ((120 * w + 220) * 1.034) / 7.6,
    "fr-std": w => ((60 * w + 170) * 1.034) / 7.6,
    "de-std": w => ((60 * w + 170) * 1.034) / 7.6,
    "id-std": w => ((80 * w + 77) * 1.034) / 7.6,
    "ie-std": w => ((120 * w + 220) * 1.034) / 7.6,
    "il-std": w => ((84 * w + 145) * 1.034) / 7.6,
    "jp-std": w => ((47.5 * w + 136.5) * 1.034) / 7.6,
    "mo-std": w => ((12 * w + 25) * 1.034) / 7.6,
    "cn-std": w => ((25.5 * w + 42.5) * 1.034) / 7.6,
    "my-std": w => ((28 * w + 87) * 1.034) / 7.6,
    "nl-std": w => ((60 * w + 170) * 1.034) / 7.6,
    "nz-std": w => ((50 * w + 150) * 1.034) / 7.6,
    "no-std": w => ((72 * w + 215) * 1.034) / 7.6,
    "ph-std": w => ((58.5 * w + 84.5) * 1.034) / 7.6,
    "pl-std": w => ((60 * w + 170) * 1.034) / 7.6,
    "pt-std": w => ((60 * w + 170) * 1.034) / 7.6,
    "ru-std": w => ((92 * w + 200) * 1.034) / 7.6,
    "sg-std": w => ((28 * w + 87) * 1.034) / 7.6,
    "kr-std": w => ((28 * w + 87) * 1.034) / 7.6,
    "es-std": w => ((60 * w + 170) * 1.034) / 7.6,
    "se-std": w => ((60 * w + 170) * 1.034) / 7.6,
    "ch-std": w => ((74 * w + 136) * 1.034) / 7.6,
    "th-std": w => ((32 * w + 96) * 1.034) / 7.6,
    "tr-std": w => ((82 * w + 138) * 1.034) / 7.6,
    "gb-std": w => ((60 * w + 170) * 1.034) / 7.6,
    "vn-std": w => ((32 * w + 96) * 1.034) / 7.6,
    "hk-std": w => ((w <= 0.2 ? 15 : 2.75 * w + 50.25) * 1.034) / 7.6,
    "tw-std": w => ((31.5 * w + 27.5) * 1.034) / 7.6,
    "us-std": w => ((53 * w + 171) * 1.034) / 7.6
  },
  hkd: {
    greetingCard: 110,
    "faceMounting-a1": 2880,
    "faceMounting-a2": 1880,
    "canvasPrint-noFrame": 680,
    "canvasPrint-woodenFrame": 1080,
    "postcards-set12": 220,
    "postcards-set20": 320,
    "timeCapsule-empty": 380,
    "timeCapsule-2018": 380,
    printItYourself: 68,
    "au-std": w => 55.75 * w + 170.25,
    "be-std": w => 60 * w + 170,
    "br-std": w => 120 * w + 220,
    "kh-std": w => 80 * w + 77,
    "ca-std": w => 70.5 * w + 200.5,
    "dk-std": w => 120 * w + 220,
    "fi-std": w => 120 * w + 220,
    "fr-std": w => 60 * w + 170,
    "de-std": w => 60 * w + 170,
    "id-std": w => 80 * w + 77,
    "ie-std": w => 120 * w + 220,
    "il-std": w => 84 * w + 145,
    "jp-std": w => 47.5 * w + 136.5,
    "mo-std": w => 12 * w + 25,
    "cn-std": w => 25.5 * w + 42.5,
    "my-std": w => 28 * w + 87,
    "nl-std": w => 60 * w + 170,
    "nz-std": w => 50 * w + 150,
    "no-std": w => 72 * w + 215,
    "ph-std": w => 58.5 * w + 84.5,
    "pl-std": w => 60 * w + 170,
    "pt-std": w => 60 * w + 170,
    "ru-std": w => 92 * w + 200,
    "sg-std": w => 28 * w + 87,
    "kr-std": w => 28 * w + 87,
    "es-std": w => 60 * w + 170,
    "se-std": w => 60 * w + 170,
    "ch-std": w => 74 * w + 136,
    "th-std": w => 32 * w + 96,
    "tr-std": w => 82 * w + 138,
    "gb-std": w => 60 * w + 170,
    "vn-std": w => 32 * w + 96,
    "hk-std": w => (w <= 0.2 ? 15 : 2.75 * w + 50.25),
    "tw-std": w => 31.5 * w + 27.5,
    "us-std": w => 53 * w + 171
  }
};
export default data;

export const getProductPrice = ({ currency, productId, optionId }) =>
  data[currency][optionId ? `${productId}-${optionId}` : productId];

export const getShippingCost = ({ currency, dest, method, weight }) => {
  if (weight === 0) return 0;
  const id = `${dest}-${method}`;
  const costFunc = data[currency][id];
  return Math.round(costFunc(weight) * 10) / 10;
};



// WEBPACK FOOTER //
// ./src/data/prices.js